import React from 'react';
import SolutionPageLayout from '../../components/SolutionPageLayout';
import ClientImage from '../../assets/generated-pages/client-managed-ai.png';

export default function Client() {
  return (
    <SolutionPageLayout
      eyebrow="Client Managed"
      title="Client Managed Engagement"
      subtitle="Your vision, our expertise, delivered on your terms."
      description="This model keeps your team in control of priorities, decisions, and delivery direction while Vedalytics provides AI expertise, development support, solution architecture, and technical execution whenever you need it."
      image={ClientImage}
      stats={[
        { value: 'Full', label: 'project control' },
        { value: 'On-demand', label: 'AI and engineering expertise' },
        { value: 'Flexible', label: 'engagement scaling' },
        { value: 'Aligned', label: 'with your internal workflows' },
      ]}
      highlights={[
        { icon: 'check', title: 'Full Control', text: 'You own the roadmap, priorities, and decisions while we support execution and technical delivery.' },
        { icon: 'ai', title: 'On-Demand Expertise', text: 'Access AI, data science, architecture, and development expertise without long-term overhead.' },
        { icon: 'layers', title: 'Scalable Support', text: 'Scale resources and capabilities as your initiative evolves from concept to deployment.' },
      ]}
      overviewTitle="You lead, Vedalytics supports"
      overviewText="Client Managed Engagement is ideal when your organization has strong internal ownership and needs specialist expertise to accelerate AI development, integration, testing, or deployment without giving up strategic control."
      overviewPoints={[
        'Your team defines project goals, priorities, and success criteria.',
        'Vedalytics provides technical execution, consulting, and AI delivery support.',
        'Flexible collaboration fits your existing governance and reporting model.',
        'Useful for innovation teams, enterprise AI programs, and internal product groups.',
      ]}
      workflowTitle="How client-managed delivery works"
      workflow={[
        { title: 'Define Objectives', text: 'Your team outlines business goals, scope, requirements, and project governance.' },
        { title: 'Add Expertise', text: 'Vedalytics contributes AI, data, engineering, and architecture skills where needed.' },
        { title: 'Validate Together', text: 'Solutions are tested against performance, usability, integration, and business expectations.' },
        { title: 'Deploy Under Your Lead', text: 'Final integration and rollout stay aligned with your internal systems and operating rhythm.' },
      ]}
      outcomesTitle="Where this model works best"
      outcomes={[
        'Internal AI research and innovation programs.',
        'Enterprise AI integration managed by in-house teams.',
        'Projects needing specialist execution without shifting ownership.',
        'Scalable development support for teams with limited bandwidth.',
      ]}
    />
  );
}
